import { fireReadyEvent } from './events';

export const register = (tagName: string) => descriptor => ({
  ...descriptor,
  finisher(clazz) {
    registerImpl(tagName, clazz);
  },
});

// exported for testing
export function registerImpl(tagName: string, clazz: any) {
  if (!window.customElements.get(tagName)) {
    window.customElements.define(tagName, clazz);
    fireReadyEvent(tagName, 'katal-component-ready');
  }
}
